import { render, staticRenderFns } from "./LicensePlate.vue?vue&type=template&id=0776a65b&scoped=true"
import script from "./LicensePlate.vue?vue&type=script&lang=ts"
export * from "./LicensePlate.vue?vue&type=script&lang=ts"
import style0 from "./LicensePlate.vue?vue&type=style&index=0&id=0776a65b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0776a65b",
  null
  
)

export default component.exports